module.exports = __webpack_public_path__ + "img/hedi-viktor.6e2aa4ed.jpg";